<template>
<div>
  <v-app>
   <v-dialog v-model="dialog" max-width="600px">
      <v-card class="withoutHeader">
         <v-card-title>
           </v-card-title>
        <v-card-text>
          <span class="headline">{{title}}</span>
          <p>{{message}}</p>
          <span>{{optionalMessage}}</span>
        </v-card-text>
          <a @click="()=> emitToParent('closePopup',this)" class="btn block">fechar</a>
           <v-card-title>
           </v-card-title>
      </v-card>
    </v-dialog>
  </v-app>
</div>

</template>

<script>
import {VDialog,VCard,VCardTitle,VCardText,VApp} from 'vuetify/lib'
import {emitToParent} from '../helpers/helpers'


export default {
  name: 'PopupMessage',
  props: {
      message:{
        type:String
      },
      optionalMessage:{
        type:String
      },
      title:{
          type:String
      },
      dialog:{
        type:Boolean
      }
  },
  methods:{
    emitToParent
  },
  components:{

    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VApp
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/popup.scss";
</style>
